var _module_exports = "<span>Your coupon discount will be deducted from the final price.</span>\n";;
var path = 'views/flashes/coupon_code_logged_in.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;